import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import router from "./routes"
import axios from 'axios'
import ValidationErrors from './components/common/ValidationErrors';
import store from './store';
import users from './Apis/users';
const VueUploadComponent = require('vue-upload-component');
// import GSignInButton from 'vue-google-signin-button'

import VueAxios from 'vue-axios'
import VueSocialauth from 'vue-social-auth'

Vue.use(VueRouter);
Vue.config.devtools = true
Vue.use(VueAxios)

// Vue.use(VueSocialauth, {
//   providers: {
//     facebook: {
//       appId: '251601126412367',
//       redirectUri: 'http://localhost:8080/signup' // Your client app URL
//     }
//   }
// })

Vue.prototype.$axios = axios
axios.defaults.withCredentials = true;
Vue.component("v-errors", ValidationErrors);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('file-upload', VueUploadComponent);
Vue.use(VueSocialauth, {
  providers: {
    google: {
      clientId: '390962648738-bdk03u3f676j8fqcavp0nmcch70cneps.apps.googleusercontent.com',
      redirectUri: `${process.env.APP_URL}signup` // Your client app URL
    },
    facebook: {
      clientId: '467832051108417',
      // redirectUri: `${process.env.APP_URL}/signup` // Your client app URL
      redirectUri: `${process.env.APP_URL}signup` // Your client app URL
    }
  }
})

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})

axios.interceptors.response.use(
  response => {
    console.log("Within interceptor response");
      return response
  },
  error => {
    console.log("Within interceptor error");
      if (401 == error.response.status) {
    console.log("Within interceptor error -");

          store.dispatch("islogut");
          users.logout();
          const logoutError = "Your session was expired. Please login again.";
          router.push({ name: 'login', params: { logoutError: logoutError } });
      }

      return Promise.reject(error);
  });

 


// WEBPACK FOOTER //
// ./src/main.js